<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    class="modal"
  >
    <Preloader v-if="isLoading" />
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">{{title}}</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons">
          close
        </span>
      </button>
    </template>
    <FormGenerator
      :data="form.fields"
      :submitButtonText="submitButtonText"
      @submit="submit"
      @input="changeFormFields($event)"
      @updateItem="updateItemFormFields"
    />

    <span variant="danger" v-show="checkCurrentDate">The data for this date is in the table.</span>
  </b-modal>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import Preloader from '@components/Preloader'
import { cloneDeep } from 'lodash'
import Moment from 'moment'

export default {
  components: {
    FormGenerator,
    Preloader
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String
    },
    submitButtonText: {
      type: String
    },
    value: {
      type: Boolean
    },
    tableData: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    const defaultForm = {
      fields: {
        'balance_date': {
          type: 'datepicker',
          name: 'balance_date',
          label: 'Balance Date',
          format: 'yyyy-MM-dd',
          placeholder: 'Balance Date',
          class: 'col-12',
          value: Moment().format('YYYY-MM-DD')
        }
      }
    }
    return {
      defaultForm,
      form: cloneDeep(defaultForm),
      checkCurrentDate: false
    }
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        if (this.value && !Object.keys(this.formData).length) {
          this.form = cloneDeep(this.defaultForm)
        } else {
          this.form = this.formData
        }
      }
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    submit (data) {
      // this.$emit('submit', data)
    },
    changeFormFields (event) {
      this.form.fields = event
    },
    updateItemFormFields (key) {
      if (this.tableData.length && this.tableData.map(item => item.balance_date).some(this.form.fields[key].value)) {
        this.checkCurrentDate = true
        return
      }

      this.checkCurrentDate = false
    }
  }
}
</script>

<style>

</style>
